import React from "react";
import {Box} from "@mui/material";
import NavBar from "../NavBar/NavBar";
import B2CSignIn from "../../auth/B2CSignIn";
import AzureSignIn from "../../auth/AzureSignIn";
import {useAuth} from "../../../hooks/useAuth";
import './SignIn.scss';
import {useNavigate} from "react-router-dom";
import SelfRegistrationCard from "../../auth/SelfRegistrationCard";
import FooterData from "../NavBar/FooterData";
import {Footer} from "@inovua/reactdatagrid-community/packages/Calendar";
import { setLogoutInProgress } from "../../../utils/authUtils";

const SignIn: React.FC = () => {
  const { isAuthenticated, isExternal, isInternal, isAuthenticating } = useAuth();
  const navigate = useNavigate();

  // Clear logout flag when SignIn page loads
  React.useEffect(() => {
    setLogoutInProgress(false);
  }, []);

  // Handle navigation for authenticated users
  React.useEffect(() => {
    if (isAuthenticated && !isAuthenticating) {
      if (isExternal) {
        navigate('/external-home');
      } else if (isInternal) {
        navigate('/internal-home');
      }
    }
  }, [isAuthenticated, isExternal, isInternal, isAuthenticating, navigate]);

  // Show loading if authentication is in progress
  if (isAuthenticating) {
    return (
      <>
        <NavBar />
        <div className="page-margin">
          <Box sx={{ width: '100%', maxWidth: 1000, textAlign: 'center', py: 4 }}>
            <h2>Signing you in...</h2>
            <p>Redirecting to your dashboard...</p>
          </Box>
        </div>
        <FooterData styles={true} />
      </>
    );
  }

  const handleSelfRegistrationClick = () => {
    navigate('/self-registration');
  };

  return (
    <>
      <NavBar />
      <div className="page-margin">
        <Box sx={{ width: '100%', maxWidth: 1000 }}>
          <h2 className="landing-heading-title">
            Welcome to Common Identity Access and Authorization Management
          </h2>
          <p>
            An Identity Application that unifies access to all DHHS applications for both
            internal and external users.
          </p>
          <p>Please select one of the options below.</p>
        </Box>

        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'flex-start'
        }}>
          <Box
            sx={{
              width: 280,
              height: 200,
              minWidth: 280,
              minHeight: 200,
              maxWidth: 280,
              maxHeight: 200,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              cursor: 'pointer'
            }}
          >
            <B2CSignIn />
          </Box>
          <Box
            sx={{
              width: 280,
              height: 200,
              minWidth: 280,
              minHeight: 200,
              maxWidth: 280,
              maxHeight: 200,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              cursor: 'pointer'
            }}
          >
            <AzureSignIn />
          </Box>
          <Box
            sx={{
              width: 280,
              height: 200,
              minWidth: 280,
              minHeight: 200,
              maxWidth: 280,
              maxHeight: 200,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              cursor: 'pointer'
            }}
          >
            <SelfRegistrationCard />
          </Box>
        </Box>
      </div>
      <FooterData
          styles={true}
      />
    </>
  );
};

export default SignIn;
